import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/sign-up.css';
import { FaHeadset } from "react-icons/fa";
import { LuLanguages } from "react-icons/lu";

function Signup() {
    const [fullname, setFullname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState('');
    const navigate = useNavigate();

    const showAlert = (message, type) => {
        setAlertMessage(message);
        setAlertType(type);
        setTimeout(() => setAlertMessage(null), 3000); // Hide alert after 5 seconds
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Reset previous alerts
        setAlertMessage(null);

        // Validate password confirmation
        if (password !== confirmPassword) {
            showAlert('❌ Passwords do not match', 'error');
            return;
        }

        const userData = {
            username: fullname, // Assuming fullname is used as username
            email: email,
            password: password,
        };

        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${baseUrl}/users`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(userData),
            });

            const data = await response.json();
            console.log('Response:', data);

            if (response.ok) {
                showAlert('✅ Registration successful! Redirecting to login...', 'success');
                setTimeout(() => navigate('/login'), 1000);
            } else {
                showAlert(`❌ ${data.message || 'Registration failed'}`, 'error');
            }
        } catch (error) {
            console.error('Error during registration:', error);
            showAlert('❌ Server error. Please try again later.', 'error');
        }
    };

    return (
        <div className="signup-page">
            <nav className="navbar">
                <div className="navbar-logo">OANDA</div>
                <div className="navbar-icons">
                    <FaHeadset className="icon" />
                    <LuLanguages className="icon" />
                </div>
            </nav>

            <div className="login-container">
                {/* ✅ Alert Box */}
                {alertMessage && (
                    <div className={`alert-box ${alertType}`}>
                        {alertMessage}
                    </div>
                )}

                <form onSubmit={handleSubmit} autoComplete="off">
                    <h6>Sign up</h6>

                    <div className="form-group">
                        <label htmlFor="fullname">Full Name *</label>
                        <input
                            type="text"
                            id="fullname"
                            value={fullname}
                            onChange={(e) => setFullname(e.target.value)}
                            required
                            className="custom-input"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="custom-input"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password *</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="custom-input"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirm_password">Confirm Password *</label>
                        <input
                            type="password"
                            id="confirm_password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="custom-input"
                        />
                    </div>

                    <button type="submit" className="btn" style={{ width: '100%', marginTop: '20px' }}>
                        REGISTER
                    </button>

                    <p className="signup-text">
                        <a href="/login">Go Back Sign In</a>
                    </p>
                </form>
            </div>
        </div>
    );
}

export default Signup;
